import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/binaryclock.pdf'; 
import { Helmet } from 'react-helmet';
import Mobile from '../images/binaryclock.png';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
        Shelfmark LBr. 916 Bl. 44r<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: 1716 (?)<br /><br />
        Translated from the German<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (127k)</Link><br /><br />
        For more information on this text, see my article &quot;Leibniz's tactile binary clock&quot; <a href="https://protect-eu.mimecast.com/s/OoYjCKYrWIPz1WRS3oUDL?domain=lisa.gerda-henkel-stiftung.de" target="_blank">here</a>.<br /><br />
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Tactile Binary Clock</title>
            <meta name="description" content="An English translation of TACTILE BINARY CLOCK by Gottfried Wilhelm Leibniz, from 1716 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <td className="pdf-container">
                    <h2 className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: TACTILE BINARY CLOCK</h2>
                    {isMobile ? renderLinks() : ''}
                    {isMobile ? <><img src={Mobile} width="100%"/></> : <embed src={pdf} className="responsive-embed"/>}
		              </td>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;